import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeformat',
  pure: false
})
export class TimeFormatPipe implements PipeTransform {
  transform(value: any, arg1: any): any {
    if (isNaN(value)) return 'N/A';

    // convert hour to 12hr format
    if (arg1 === '12hr') {
      let time = value;
      // Check correct time format and split into components
      time = time
        .toString()
        .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
      time[1] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
      return time.join(''); // return adjusted time or original string
    }

    if (arg1 === '24hr') {
      let time = value;
      return time + ':00';
    }

    // convert number into day of week
    if (arg1 === 'dayOfWeek') {
      const days = [
        '',
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
      ];
      return days[value];
    }

    return value;
  }
}
